import { Environment } from "./Base";

const Category = "Lebanon20";

const GA_Push = (event = "GA_Event", action, label="Lebanon20", _category) => {
  var data = {
    event,
    Category: _category ? _category : Category,
    Action: action,
    Label: label
  };
  if (window.dataLayer) {
    window.dataLayer.push(data);
  }
  _log(data);
};
const GA_VPush = (title, url) => {
  var data = {
    event: "virtualPageview",
    virtualPageURL: url ? url : window.location.pathname,
    virtualPageTitle: title ? title : window.document.title
  };
  if (window.dataLayer) {
    window.dataLayer.push(data);
  }
  _log(data);
};

const _log = data => (Environment().isLocalhost || Environment().isQA ? console.log(data) : null);

export { GA_Push, GA_VPush };
